import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Trash2 } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const ChannelModal = ({ channel, onClose, onSaved }) => {
  const { user: me } = useAuth();
  const [label, setLabel] = useState(channel?.label || "");
  const [users, setUsers] = useState([]);
  const [members, setMembers] = useState([]);
  useEffect(() => {
    http.get("/auth/users").then((r) => {
      setUsers(r.data.filter((u) => u.id !== me?.id && (u.role === "admin" || u.permissions == null || u.permissions.includes("messages"))));
      if (channel) setMembers(r.data.filter((u) => (u.channels || []).includes(channel.key)).map((u) => u.id));
    });
  }, [channel, me?.id]);
  const toggle = (id) => setMembers((m) => (m.includes(id) ? m.filter((x) => x !== id) : [...m, id]));
  const save = async () => {
    try {
      if (channel) await http.put(`/messages/channels/${channel.key}`, { label, members });
      else await http.post("/messages/channels", { label, members });
      toast.success(channel ? "Canal mis à jour" : "Canal créé"); onSaved(); onClose();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async () => {
    if (!window.confirm(`Supprimer le canal « ${channel.label} » ? Ses messages ne seront plus accessibles.`)) return;
    try { await http.delete(`/messages/channels/${channel.key}`); toast.success("Canal supprimé"); onSaved(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 grid place-items-center p-4" data-testid="channel-modal">
      <div className="bg-white rounded-md w-full max-w-md max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center px-5 py-3 border-b border-slate-200">
          <h3 className="font-bold">{channel ? `Canal « ${channel.label} »` : "Nouveau canal"}</h3>
          <button data-testid="channel-modal-close" onClick={onClose} className="ml-auto p-1 rounded hover:bg-slate-100"><X className="h-4 w-4" /></button>
        </div>
        <div className="p-5 space-y-3 overflow-auto">
          <input data-testid="channel-name" className="input" maxLength={40} placeholder="Nom du canal (ex. Direction)" value={label} onChange={(e) => setLabel(e.target.value)} />
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Utilisateurs ayant accès</div>
          <div className="space-y-1" data-testid="channel-members">
            {users.map((u) => (
              <label key={u.id} className="flex items-center gap-2 text-sm px-2 py-1.5 rounded hover:bg-slate-50 cursor-pointer">
                <input data-testid={`channel-member-${u.id}`} type="checkbox" checked={members.includes(u.id)} onChange={() => toggle(u.id)} />
                {u.name}<span className="text-xs text-slate-400 truncate">{u.email}</span>
              </label>
            ))}
          </div>
          <p className="text-[11px] text-slate-500">L&apos;administrateur principal voit tous les canaux. Seuls les utilisateurs ayant accès à la Messagerie sont listés.</p>
        </div>
        <div className="flex items-center gap-2 px-5 py-3 border-t border-slate-200 bg-slate-50">
          {channel && <button data-testid="channel-delete" onClick={remove} className="inline-flex items-center gap-1 text-sm font-semibold text-rose-600 hover:underline"><Trash2 className="h-4 w-4" />Supprimer</button>}
          <button onClick={onClose} className="ml-auto px-4 py-2 text-sm font-semibold border border-slate-300 rounded-md hover:bg-slate-100">Annuler</button>
          <button data-testid="channel-save" disabled={!label.trim()} onClick={save} className="px-4 py-2 text-sm font-semibold text-white rounded-md disabled:opacity-50" style={{ backgroundColor: "var(--brand-primary)" }}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
};
